import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getContentDealIdLookupData } from 'modules/api/lookups';
import Local from 'modules/Local';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { onFilterChange } from 'store/pages/contentManagement/creativeSetDetails/reducer';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';

type FilterContentDealIdProps = {
  placeholder?: string;
};

const FilterContentDealId: React.FC<FilterContentDealIdProps> = ({ placeholder = 'Select deal ID' }) => {
  const dispatch = useDispatch();
  const dealId = useSelector((state: RootState) => state.pages.contentManagement.creativeSetDetails.filters.dealId);

  const onLoadDealIdLookupData: AsyncSelectLoadDataHandler<CodeNameModel[]> = async (_, query) => {
    if (query.length < 2) return [];

    try {
      return await getContentDealIdLookupData(cancelFunctions, Local.getEnvironmentId(), query);
    } catch (error) {
      return [];
    }
  };

  const onSelect: SelectHandler<CodeNameModel> = (_, value: CodeNameModel) => {
    dispatch(onFilterChange({ dealId: value }));
  };

  return (
    <AsyncSelect
      dataTestId="filter-area-deal-id"
      name="dealId"
      loadData={onLoadDealIdLookupData}
      selectedValue={dealId}
      placeholder={placeholder}
      onSelect={onSelect}
    />
  );
};

export default FilterContentDealId;
